import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MonitoramentoService {

  constructor() { }

  formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  checkDateTime(inputElement: HTMLInputElement) {
    const now = new Date();
    var currentDate = this.formatDateTime(now);
    const selectedDateTime = new Date(inputElement.value);
    const currentDateTime = new Date(currentDate);

    if (selectedDateTime > currentDateTime) {
      abp.notify.info("Não é possível adicionar uma hora fultura");
      currentDateTime.setMinutes(currentDateTime.getMinutes() - selectedDateTime.getTimezoneOffset());
      const formattedDate = currentDateTime.toISOString().slice(0, 16);
      inputElement.value = formattedDate;
      return formattedDate;
    }
    return null;
  }
}
